import Image from 'react-bootstrap/Image';
// import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import userProfileIcon from '../../assets/img/user_profile_icon.svg';
import * as actions from '../../modules/permissions/store/actions';
// import { useComponentDidMount } from '../../modules/core/hooks';
import { UserProfile } from 'modules/auth/store/userAPI';
import { UserRoleInterface } from 'modules/auth/store/roleApi';
import { useEffect, useMemo } from 'react';

interface ProfileInfoProps {
  user?: UserProfile
  userRoles?: UserRoleInterface[]
  variant?: string
  showFullInfo?: boolean
  getUserRoles?(...args: unknown[]): unknown
  loadingUserRoles?: boolean
  minimal?: boolean
}

const ProfileInfo = ({
  user,
  variant,
  showFullInfo = false,
  getUserRoles,
  userRoles,
  loadingUserRoles,
  minimal = false,
}: ProfileInfoProps) => {

  // getUserRoles - здесь встроено на всякий случай.
  // В момент входа в наше приложение читаем роли залогинившегося пользователя.
  // Встроил здесь вызов, если в будущем вход в прилагу переделаем и данных не будет на входе
  useEffect(() => {
    if (showFullInfo && user?.customerId && !loadingUserRoles && !userRoles?.length) {
      getUserRoles?.(user);
    }
  }, [user, showFullInfo, userRoles, loadingUserRoles, getUserRoles]);

  const rolesString = useMemo(() => {
    if (!userRoles?.length) return '';
    return userRoles.filter(v => v.available).map(v => v.roleName).join(',');
  }, [userRoles]);

  // Если нет пользователя – ничего не рендерим (или можно показать заглушку)
  if (!user) return null;

  return (
    <nav className='profile'>
      <Image
        src={ user.avatarUrl || userProfileIcon }
        roundedCircle
        width='35'
        height='35'
        className='profile__avatar'
      />
      { !minimal && (
        <div className='profile__bio'>
          <span className={ `profile__name ${ variant && `profile__name_${ variant }` }` }>
            { user.firstName } { user.lastName }
          </span>
          <span className={ `profile__partner ${ variant && `profile__partner_${ variant }` }` }>
            { user.partner?.name || '' }
          </span>
          { (showFullInfo) && (
            <span className={ `profile__name ${ variant && `profile__name_${ variant }` }` }>
              { user.email }
            </span>
          ) }
          { (showFullInfo) && (userRoles?.length > 0) && (
            <span className={ `profile__name ${ variant && `profile__name_${ variant }` }` }>
              { rolesString }
            </span>
          ) }
        </div>
      ) }
    </nav>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth?.profile,
    userRoles: state.permissions?.userRoles,
    loadingUserRoles: state.permissions?.loadingUserRoles,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getUserRoles: payload => dispatch(actions.getUserRoles(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileInfo);
